// extracted by mini-css-extract-plugin
export default {"JackpotModalOverlay":"JackpotModal_JackpotModalOverlay__PjeJJ"};